module.exports = __webpack_public_path__ + "img/1.0e456227.png";